export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/alert', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getAlertList = async (searchText) => {
    try {
        const result = await get(`alert?1=1${searchText ? `&search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getSpecialAlert = async () => {
    try {
        const result = await get(`alert/special`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getAlertContent = async (newsId) => {
    try {
        const result = await get(`alert/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createAlert = async (data) => {
    try {
        const result = await post('alert', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateCover = async (id, data) => {
    try {
        const result = await put(`alert/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteAlert = async (id) => {
    try {
        const result = await destroy(`alert/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`alert/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
